import { render, staticRenderFns } from "./DashboardPPCM.vue?vue&type=template&id=f475d008&scoped=true&"
import script from "./DashboardPPCM.vue?vue&type=script&lang=js&"
export * from "./DashboardPPCM.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPPCM.scss?vue&type=style&index=0&id=f475d008&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f475d008",
  null
  
)

export default component.exports